import script from "./form-api.vue?vue&type=script&setup=true&lang=js"
export * from "./form-api.vue?vue&type=script&setup=true&lang=js"

import "./form-api.vue?vue&type=style&index=0&id=f60c1d18&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f60c1d18"]])

export default __exports__